import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';

import InviteFriendModal from '../../../../components/InviteFriendModal';

import Spinner from '../../../../../../components/Spinner';
import Segment from '../../../../../../components/Segment';

import './JoinSessionPage.scss';

// Company Images
import McKinseyCompanyLogo from './images/companies/McKinsey_and_Company_Logo.png';
import MicrosoftLogo from './images/companies/microsoft.png';
import GoldmanSachsLogo from './images/companies/goldman-sachs-logo.png';
import AppleLogo from './images/companies/apple.png';
import DeloitteLogo from './images/companies/Deloitte-logo.png';
import BainLogo from './images/companies/bain.png';
import GoogleLogo from './images/companies/google.png';
import PWCLogo from './images/companies/pwc.png';
import MorganStanleyLogo from './images/companies/morgan-stanley.png';
import FacebookLogo from './images/companies/facebook.png';
import CitiLogo from './images/companies/citi-logo.png';
import NetflixLogo from './images/companies/Netflix_logo.png';
import NYULangoneLogo from './images/companies/NYULangone_Logo.png';
import YahooLogo from './images/companies/yahoo-logo.png';
import BAHLogo from './images/companies/bah-only-logo.png';

import HeroImage1 from './images/OH-Header-3.jpg';
import FooterImage1 from './images/Depositphotos_53801085.jpg';
import CancelImage from './images/cancel.png';

import ZoomInstructions1 from './images/zoom-instructions-1.jpg';
import ZoomInstructions2 from './images/zoom-instructions-2.jpg';
import ZoomInstructions3 from './images/zoom-instructions-3.jpg';

import FacebookLogoImage from './images/logo-facebook.png';
import EmailImage from './images/mail-logo.png';

import WeChatLogo from './images/wechat-logo.png';
import QRImage from './images/qr-code.png';

import { facebookShare } from 'components/Utils';

import MattHeadshot from './images/matt_headshot.png'; // TEST IMAGE

const segment = new Segment();

const monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
// eslint-disable-next-line
const EmailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

class ViewOfficeHours extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      inviteFriendModalIsOpen: false,
      dataLoaded: false,
      meetingReady: false,
      meetingOver: false,
    };

    this.setInviteModal = this.setInviteModal.bind(this);
    this.facebookShareThisPage = this.facebookShareThisPage.bind(this);
  }

  componentDidMount () {
    segment.page();

    // Set up a check to see if the session data has been loaded and the link for the session should be displayed
    this.timeChecker = setInterval(() => {
      if (this.props.SessionData.loading === false) {
        if (!this.state.dataLoaded) this.setState({ dataLoaded: true });
        let SessionEntry = this.props.SessionData.getOfficeSessions.find(x => x.id === parseInt(this.props.routeParams.id, 10));
        if (typeof SessionEntry !== 'undefined') {
          if (moment(SessionEntry.start_time).diff(moment(), 'minutes') < 31) {
            this.setState({ meetingReady: true });

            if (moment(SessionEntry.start_time).diff(moment(), 'minutes') < -60) {
              this.setState({ meetingOver: true });
              clearInterval(this.timeChecker);
            }
          }
        } else {
          clearInterval(this.timeChecker);
        }
      }
    }, 500);
  }

  componentWillUnmount () {
    // remove the check from componentDidMount()
    clearInterval(this.timeChecker);
  }

  setInviteModal (val) {
    return () => this.setState({
      inviteFriendModalIsOpen: val,
    });
  }

  facebookShareThisPage (evt) {
    evt.preventDefault();

    segment.track('Initiated a facebook share', {
      page: window.location
    });

    return facebookShare();
  }

  renderSession () {
    if (this.state.dataLoaded) {
      const SessionEntry = this.props.SessionData.getOfficeSessions.find(x => x.id === parseInt(this.props.routeParams.id, 10));
      if (typeof SessionEntry !== 'undefined') {
        const StartDate = moment(SessionEntry.start_time).tz('America/New_York');
        const TimeZone = 'EST';

        return (
          <div className='OfficeHour__WholeWrap'>
            <h5 className='OfficeHour__TimeHeader'>
              {StartDate.format('MMM. DD | hh:mm a')} {TimeZone}
            </h5>
            <h3>{SessionEntry.advisor_bio}</h3>
            <div className='row'>
              <div className='col-3'>
                <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + SessionEntry.host.photo} className='OfficeHour__AdvisorImage' />
                <h5 className='OfficeHour__HostName'>{SessionEntry.host.first_name + ' ' + SessionEntry.host.last_name}</h5>
                <p className='OfficeHour__AdvisorBio'>{SessionEntry.title}</p>
                <p>{SessionEntry.company_1}</p>
                <p>{SessionEntry.company_2}</p>
              </div>
              <div className='col-9 text-left'>
                <p><br /></p>
                <div dangerouslySetInnerHTML={{ __html:SessionEntry.host.advisor_info.advisor_summary_intro && SessionEntry.host.advisor_info.advisor_summary_intro.replace(/(?:\r\n|\r|\n)/g, '<br />') }} />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                {SessionEntry.zoom_meeting_id ? (
                  this.state.meetingReady
                  ? (this.state.meetingOver
                    ? (
                      <div>
                        <p className='font-italic font-weight-bold'>This Meeting is Over</p>
                      </div>
                    ) : (
                      <div>
                        <a className='button' href={'https://zoom.us/j/' + SessionEntry.zoom_meeting_id} target='_blank'>
                          Click here to join this tea time!
                        </a>
                        <div className='OfficeHour__ZoomInstructions'>
                          <h5>Instructions:</h5>
                          <ol>
                            <li>Click the link above or the Zoom link on your Google Calendar Invite</li>
                            <li>When you are redirected to the Zoom website, click “Open Zoom Meetings”, and then selected “download”. The app will begin to download on your computer. <br /><img src={ZoomInstructions1} /></li>
                            <li>Once the app is installed, click it and type in your name to create an account.<br /><img src={ZoomInstructions2} /></li>
                            <li>Select “allow video”, “allow audio”, and “Join Audio Conference by Computer”<br /><img src={ZoomInstructions3} /></li>
                            <li>Once session begins, you may start speaking to the advisor.</li>
                          </ol>
                        </div>
                      </div>
                    )
                  ) : (
                    <p className='disabled'>
                      <br />
                      <b>You will see a link to join 30 minutes before the session. Stay tuned!</b>
                    </p>
                  )
                ) : (
                  <p>Tea Time is being prepared</p>
                )}
              </div>
            </div>
            <br />
            {/* <p style={{fontWeight: '600', color: '#193865'}}>Enjoyed this Tea Time?</p>
            <a href='/signup/virtualteatime' className='button button--hollow'>
              View Other Tea Times
            </a> */}
          </div>
        );
      } else {
        return (
          <div className='OfficeHour__WholeWrap'>
            <h3>This Tea Time session does not exist</h3>
            <br />
            <p style={{ fontWeight: '600', color: '#193865' }}>Where can I find others?</p>
            <a href='/signup/virtualteatime' className='button button--hollow'>
              View Other Tea Times
            </a>
          </div>
        );
      }
    }
    return <Spinner />;
  }

  render () {
    console.log(this.props);
    return (
      <div style={{ background: '#f0f1f3', position: 'relative' }}>
        <InviteFriendModal isOpen={this.state.inviteFriendModalIsOpen} onDismiss={this.setInviteModal(false)} sendEmailInvite={this.props.SendEmailInvite} />
        <div className='HeroSection HeroSection--Small'>
          <div className='HeroSection__BackGroundWrap'>
            <img src={HeroImage1} />
          </div>
          <div className='HeroSection__ContentWrap'>
            <div className='container'>
              <div className='row'>
                <div className='col-lg-8 col-md-10'>
                  <h1 className='heading-1'>Secrets to Securing Your Dream Career</h1>
                  <p className='subhead-1'>
                    Get free career advice from some of America’s most accomplished professionals. How can you get your dream role? Or break into a new industry? Ask anything - and learn what you need to be successful.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='OfficeHours__Wrapper' ref='OfficeHourAnchor'>
          <div className='container'>
            <div className='row'>
              {this.renderSession()}
            </div>
          </div>
        </div>
        <div className='MoreSecrets__Wrapper'>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h3>Want more career secrets?</h3>
                <p className='text-center'>
                  <a className='btn btn-info' href='/signup/careerQandA'>
                    Join Other Sessions
                  </a>
                </p>
              </div>
            </div>
            <div className='foobar'>
              <div className='MoreSecrets__CompanyLogos hidden-xs-down'>
                <p className='MoreSecrets__SubText'>Our professionals have experience at companies including:</p>
                <div className='MoreSecrets__CompanyImageWrap'>
                  <img src={McKinseyCompanyLogo} height='50' />
                  <img src={MicrosoftLogo} height='50' />
                  <img src={GoldmanSachsLogo} height='80' />
                  <img src={AppleLogo} height='60' />
                  <img src={DeloitteLogo} height='50' />
                  <img src={BainLogo} height='70' />
                  <img src={GoogleLogo} height='55' />
                  <img src={PWCLogo} height='65' />
                  <img src={FacebookLogo} height='50' />
                  <img src={CitiLogo} height='50' />
                  <img src={NetflixLogo} height='50' />
                  <img src={NYULangoneLogo} height='90' />
                  <img src={YahooLogo} height='60' />
                  <img src={MorganStanleyLogo} height='50' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='FooterImage'>
          <div className='FooterImage__BackGroundWrap'>
            <img src={FooterImage1} />
          </div>
          <div className='FooterImage__ContentWrap'>
            <div className='container'>
              <div className='FooterImage__InternalWrap'>
                <p className='FooterImage__MinorTitle'>Paragon One provides personalized career and entrepreneurship coaching for college students and working professionals. Our programs combine mentoring and exclusive online courses. Originally started as an invite-only mentor network at MIT 10 years ago, Paragon One has now enabled its clients to secure internships and jobs with the most highly respected US companies.</p>
                <a href='https://www.paragonone.com/' className='button button--trim'>Learn more about Paragon One</a>
              </div>
            </div>
          </div>
        </div>
        <footer className='OfficeHours'>
          <div className='container'>
            <div className='row'>
              <div className='col-sm'>
                <h5>Contact Us</h5>
                <p>info@paragonone.com<br />1-888-527-6888</p>
              </div>
              <div className='col-sm'>
                <div className='FooterImage__InternalWrap'>
                  <p className='SegmentSubTitle'>Be someone's career hero!<br />Share Office Hours with a friend:</p>
                  <div className='row SocialIntergrations'>
                    <a href='#' onClick={this.facebookShareThisPage}>
                      <img style={{ padding: '1px 14px 0px 11px' }} src={FacebookLogoImage} />
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={this.setInviteModal(true)}>
                      <img src={EmailImage} style={{ height: '60px' }} />
                    </a>
                  </div>
                </div>
              </div>
              <div className='col-sm'>
                <img style={{ height: '75px' }} src={QRImage} />
                <img style={{ height: '45px', marginTop: '15px' }} src={WeChatLogo} />
              </div>
            </div>
            <div className='row'>
              <p className='copy'>&copy; 2017 Paragon One, All Rights Reserved</p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default ViewOfficeHours;



// WEBPACK FOOTER //
// ./src/routes/officehours-v2/routes/JoinPage/components/JoinSessionPage/index.js